import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import menues, { MenuInfo } from './menu'
import MenuList from './MenuList.vue'
import LoginInfo from './LoginInfo.vue'
import NodeList from './NodeList.vue'
import { mapGetters, mapMutations } from 'vuex'
import * as types from '@/store/types'
@Component({
    components: { LoginInfo, MenuList, NodeList },
    computed: {
        ...mapGetters({
            showSidebar: types.SIDEBAR_VISIBLE,
            currentMenu: types.CURRENT_MENU
        })
    },
    methods: {
        ...mapMutations({
            setShowSidebar: types.SIDEBAR_VISIBLE
        })
    }
})
export default class Sidebar extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    showSidebar!: boolean
    currentMenu!: string

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    currentMenuInfo: any = null

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get menues(): MenuInfo[] {
        return menues.filter(x => x.isUse)
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setShowSidebar!: (show: boolean) => void

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    getCurrentMenuInfo(name: string) {
        this.currentMenuInfo = menues.filter(x => x.name === name)[0]
    }

    closeSidebar() {
        this.setShowSidebar(false)
    }

    @Watch('currentMenu')
    onChangeSelectValue() {
        this.getCurrentMenuInfo(this.currentMenu)
    }

    @Watch('showSidebar')
    onChangeShowSidebar() {
        console.log('this.currentMenu', this.currentMenu)
        this.getCurrentMenuInfo(this.currentMenu)
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    
    // created() {
    //     this.getCurrentMenuInfo(this.currentMenu)
    // }
}